import { PrismaRepositoryDto } from 'app/API';

export function checkAssignedRepositories(
  me: { assignedRepositories?: PrismaRepositoryDto[] },
  organizationId: string,
) {
  return (me.assignedRepositories || []).filter((repo: PrismaRepositoryDto) => repo.organizationId === organizationId);
}
